(function () {
  function ready(fn){
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  ready(function(){
    document.querySelectorAll("[data-inkd-two-ways]").forEach(function(root){
      var defaultTab = (root.getAttribute("data-default-tab") || "popup").trim();
      var btns = Array.from(root.querySelectorAll("[data-tab-btn]"));
      var panels = Array.from(root.querySelectorAll("[data-tab-panel]"));

      function setTab(tab){
        btns.forEach(function(b){
          var active = b.getAttribute("data-tab-btn") === tab;
          b.classList.toggle("is-active", active);
          b.setAttribute("aria-selected", active ? "true" : "false");
          b.setAttribute("tabindex", active ? "0" : "-1");
        });

        panels.forEach(function(p){
          var active = p.getAttribute("data-tab-panel") === tab;
          if (active) p.removeAttribute("hidden");
          else p.setAttribute("hidden", "");
        });
      }

      btns.forEach(function(b){
        b.addEventListener("click", function(){
          setTab(b.getAttribute("data-tab-btn"));
        });
      });

      setTab(defaultTab);
    });
  });
})();
